import styled from '@emotion/styled';
import { Theme } from '@seedlang/constants';
import { ReviewIndexWrapper } from '@seedlang/hoc';
import { AppUI, DeckUI } from '@seedlang/state';
import Checkbox from 'components/checkbox';
import Filter from 'components/filter';
import SearchInput from 'components/form/search_input';
import Paginator from 'components/paginator';
import BulkEditReviews from 'components/review/bulk_edit_reviews';
import ReviewCardPanel from 'components/review/review_card_panel';
import ExpandAllButton from 'components/review/expand_all_button';
import ReviewIndexSortButton from 'components/review/review_index_sort_button';
import Spinner from 'components/spinner';
import { observer } from 'mobx-react';
import React from 'react';
import DesktopOnly from 'utils/desktop_only';
import MobileOnly from 'utils/mobile_only';

const Wrapper = styled.div`
  width: 100%;
  margin-top: ${props => props.marginTop};
`;

const ReviewsWrapper = styled.div`
  background: #FFF;
  margin-top: 10px;
`;

const SortWrapper = styled.div`
  color: #FFF;
  font-size: 14px;
  background: #636363;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  height: fit-content;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 5px;
  gap: 5px;
`;

const SortButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: 5px;
  gap: 5px;
`;

const NoResults = styled.div`
  padding: 10px 10px 30px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
`;

const MobileExpandAllButton = styled.div`
  display: flex;
  align-items: center;
  margin-right: 15px;
`;

@observer
class ReviewIndex extends React.Component {

  render() {
    return (
      <Wrapper
        marginTop={AppUI.layout.isMobile ? '10px' : null}
      >
        <SearchInput
          placeholder='Search for a Review'
          onChange={this.props.onUpdateSearchQuery}
          insertText={this.props.insertText}
          focusOnId={this.props.searchQuery}
          value={this.props.searchQuery}
          caretPosition={this.props.caretPosition}
          background='#FFF'
        />
        <Filter
          filterName='Review Filters'
          noFiltersSelectedMessage={this.props.noFiltersSelectedMessage}
          filterSettings={this.props.filterSettings}
          onSetFilter={this.props.onSetFilter}
          searchQuery={this.props.searchQuery}
          hasActiveFilter={this.props.hasActiveFilter}
          onToggleFiltersExpanded={this.props.onToggleFiltersExpanded}
          setShowFilterOptions={this.props.setShowFilterOptions}
          showFilterOptions={this.props.showFilterOptions}
          filteredItemsCount={this.props.filteredItemsCount}
          filteredItemsType='Review'
        />
        <BulkEditReviews
          selectedReviewIds={this.props.selectedCardIds}
          reviewDeckOptions={this.props.reviewDeckOptions}
          afterChange={this.props.getReviews}
          resetSelectedCards={this.props.resetSelectedCards}
        />
        <ReviewsWrapper>
          <SortWrapper>
            <Checkbox
              margin='0 0 0 15px'
              value={this.props.allSelected}
              onClick={this.props.toggleSelectAll}
            />
            <SortButtonsWrapper>
              <ReviewIndexSortButton
                column='created_at'
                onClick={this.props.onChangeSort}
                sort={this.props.sort}
                label='Created'
              />
              <ReviewIndexSortButton
                column='review_after'
                onClick={this.props.onChangeSort}
                sort={this.props.sort}
                label='Next Due'
              />
              <ReviewIndexSortButton
                column='difficulty_score'
                onClick={this.props.onChangeSort}
                sort={this.props.sort}
                label='Difficulty'
              />
              <DesktopOnly>
                <ExpandAllButton
                  onClick={this.props.toggleExpandAll}
                  expanded={this.props.allCardsExpanded}
                />
              </DesktopOnly>
            </SortButtonsWrapper>
            <DesktopOnly><div /></DesktopOnly>
            <MobileOnly>
              <MobileExpandAllButton onClick={this.props.toggleExpandAll}>
                <i className={this.props.allCardsExpanded ? 'fa fa-minus' : 'fa fa-plus'}/>
              </MobileExpandAllButton>
            </MobileOnly>
          </SortWrapper>
          {
            this.props.showSpinner &&
              <Spinner
                background={Theme.blue}
              />
          }
          {
            !this.props.showSpinner && DeckUI.cardStore.indexData.length === 0 && DeckUI.cardStore.requestCounter === 0 &&
              <NoResults>
                No reviews were found.
              </NoResults>
          }
          {
            !this.props.showSpinner && DeckUI.cardStore.indexData.map(item => (
              <ReviewCardPanel
                key={`${item.id}-${Math.random()}`}
                item={item}
                expanded={this.props.cardIsExpanded(item)}
                onToggleExpanded={() => this.props.toggleCardExpand(item)}
                checkboxValue={this.props.cardIsSelected(item)}
                onToggleCheckbox={() => this.props.toggleCardSelect(item)}
                reviewDeckOptions={this.props.reviewDeckOptions}
                onManage={() => {
                  AppUI.cardStore.showData = item;
                  AppUI.routeStore.routeToNamed('reviews.show', {
                    page: this.props.page,
                    cardId: item.id,
                  });
                }}
                onReset={() => this.props.onResetReview(item.id)}
                onDelete={() => this.props.onDelete(item.id)}
              />
            ))
          }
        </ReviewsWrapper>
        {
          this.props.showPagination &&
            <Paginator
              onClickScrollToTop
              updateUrl
              store={DeckUI.cardStore}
              queryStrings={{my_reviews: true, language_id: AppUI.targetLanguageId}}
              totalCount={this.props.filteredItemsCount}
              onPagination={this.props.resetSelectedCards}
            />
        }
      </Wrapper>
    );
  }
}

export default ReviewIndexWrapper(ReviewIndex);
